import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableSortLabel, Checkbox, Tooltip, ListItem, makeStyles, ListItemText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  headerColor: { backgroundColor: theme.palette.background.default },
  textStyles: { fontWeight: 'bold' },
}));

const MobileTableHead = ({ checked, selectAll, order, orderBy, headers, showCheckbox, onRequestSort }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <div className={classes.headerColor}>
      <ListItem>
        {showCheckbox && (
          <ListItemText padding="checkbox">
            <Checkbox checked={checked} color="primary" onChange={selectAll} />
          </ListItemText>
        )}
        {headers.map((column) => {
          if (column && column.mobilePreview === true) {
            const numeric = column.format === 'numeric';
            const display = !column.noDisplay;
            return (
              display && (
                <ListItemText key={column.dataAlias}>
                  {column.sortable ? (
                    <Tooltip title={t('Sort')} placement={numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                      <TableSortLabel
                        className={classes.textStyles}
                        active={orderBy === column.dataAlias}
                        direction={order}
                        onClick={createSortHandler(column.dataAlias)}
                      >
                        {t(column.alias)}
                      </TableSortLabel>
                    </Tooltip>
                  ) : (
                    column.alias
                  )}
                </ListItemText>
              )
            );
          }
        }, this)}
      </ListItem>
    </div>
  );
};

MobileTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string,
  tableHeaderColor: PropTypes.string,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      sortable: PropTypes.bool.isRequired,
      format: PropTypes.oneOf(['date', 'string', 'number']),
      dataAlias: PropTypes.string.isRequired,
      className: PropTypes.string,
    })
  ).isRequired,
  selectAll: PropTypes.func,
  showCheckbox: PropTypes.bool,
  checked: PropTypes.bool,
};

MobileTableHead.defaultProps = {
  showCheckbox: false,
  selectAll: undefined,
  orderBy: undefined,
  tableHeaderColor: undefined,
  checked: false,
};

export default MobileTableHead;
